import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_PROCESSO_SELETIVO_BASE_URL_0,
});

export default api;
